import React from "react";
import { enforceTermsOnCompetitionForm } from "../utils/testDriveCompetitionForm";
import PostcodeInline from "../components/Postcode/PostcodeInline";
import ReactDOM, { render } from "react-dom";
import {renderLoaderForForm} from "../components/FormSubmitLoader";

const HybridPreorder = (): void => {
  if (!document.querySelector(".hybridPreorder")) {
    return;
  }

  //form validations for checkbox (MVC client-side validations for checkbox is problematic, so we override it here)
  enforceTermsOnCompetitionForm(document.querySelector("form.hybridPreorderForm"),"You must agree to the Privacy Collection Statement."); 
  
  //customize postcode field to allow suburb search
  suburbSearchPostCodefield();

    //adding loader for form.
  renderLoaderForForm(document.querySelector("form.hybridPreorderForm"));
};

function suburbSearchPostCodefield(){

  let wrap = document.querySelector(".postcodeSelect") as any;
  //Load postcode field
   let field = wrap.querySelector("input");
   let innerWrap = wrap.querySelector(".inlinePostcodeLookup");
   let form = wrap.parentNode;
 
   while (form && form.tagName !== "FORM") {
     form = form.tagName === "HTML" ? null : form.parentNode;
   }
   let required = true;
 
   if (innerWrap.getAttribute("data-required") === "false") {
     required = false;
   }
 
   ReactDOM.render(
     <PostcodeInline required={required} emitEvents={true} fieldEl={field} formEl={form} simpleDisplay={true} />,
     innerWrap
   );
}
export default HybridPreorder;
